import api from './api';

const BASE = '/api/expenses';

export const getExpenses = (params) => api.get(BASE, { params });

export const getExpenseSummary = (params = {}) => api.get(`${BASE}/summary`, { params });

export const getExpense = (id) => api.get(`${BASE}/${id}`);

export const createExpense = (formData) =>
  api.post(BASE, formData, { headers: { 'Content-Type': 'multipart/form-data' } });

export const updateExpense = (id, formData) =>
  api.patch(`${BASE}/${id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });

export const approveExpense = (id) => api.post(`${BASE}/${id}/approve`);

export const rejectExpense = (id, reason) => api.post(`${BASE}/${id}/reject`, { reason });

export const deleteExpense = (id) => api.delete(`${BASE}/${id}`);

export const deleteAttachment = (expenseId, attachmentId) =>
  api.delete(`${BASE}/${expenseId}/attachment/${attachmentId}`);

export const cancelExpense = (id) => api.post(`${BASE}/${id}/cancel`);

export const stopRecurringExpense = (id) => api.post(`${BASE}/${id}/stop-recurring`);

export const viewAttachment = (expenseId, attachmentId, download = false) =>
  api.get(`${BASE}/${expenseId}/attachments/${attachmentId}/view${download ? '?download=1' : ''}`, { responseType: 'blob' });
